module.exports = __webpack_public_path__ + "static/img/consumed-ten.a5842234.png";